export { default, noop } from "ember-composable-helpers/helpers/noop";
